import { Constructor, IDisposable, TypeOf } from '@skylab-shared/types';
import { ListenersRegistry } from '@skylab-shared/utils';
import { ReadonlyChecker } from '../../rules/src/readonly-checker';
import { Weaver } from './../../aop';
import { ModelBase } from './../../model';
import { ReadonlyEngine, RequiredEngine, ValidationEngine } from './../../rules';
import { BusinessObjectBase } from './business-object-base';
import { CoreFeatureManager } from './core-feature-manager';

export interface BusinessObjectPartContext<TModelPart extends ModelBase> {
    readonly bo: BusinessObjectBase<TModelPart>;
    readonly coreFeature: {
        readonly propertyChanged: CoreFeatureManager;
        readonly collectionChanged: CoreFeatureManager;
    };
    readonly engine: {
        readonly validation: ValidationEngine<BusinessObjectBase<TModelPart>, TModelPart>;
        readonly readonly: ReadonlyEngine<BusinessObjectBase<TModelPart>, TModelPart>;
        readonly required: RequiredEngine<BusinessObjectBase<TModelPart>, TModelPart>;
        readonly readonlyChecker: ReadonlyChecker<BusinessObjectBase<TModelPart>, TModelPart>;
    };
}

export abstract class BusinessObjectPart<TModelPart extends ModelBase> extends ListenersRegistry(class { }) implements IDisposable {
    protected bo!: TypeOf<BusinessObjectPartContext<TModelPart>, 'bo'>;
    protected coreFeature!: TypeOf<BusinessObjectPartContext<TModelPart>, 'coreFeature'>;
    protected engine!: TypeOf<BusinessObjectPartContext<TModelPart>, 'engine'>;

    public constructor(protected readonly weaver: Weaver) {
        super();
    }

    public initializeAsync({ bo, coreFeature, engine }: BusinessObjectPartContext<TModelPart>): Promise<void> {
        this.bo = bo;
        this.coreFeature = coreFeature;
        this.engine = engine;

        return Promise.resolve();
    }

    public dispose(): void {
        this.deregisterAllListeners();
    }

    protected get modelType(): Constructor<TModelPart> {
        return <Constructor<TModelPart>> this.bo.model.constructor;
    }
}
